var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEyeRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 19,
    viewBox: "0 0 34 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1512 9.03846C33.1518 9.03915 33.1523 9.03978 32 10L33.1523 9.03977C33.6827 9.67619 33.5967 10.622 32.9603 11.1524C32.3243 11.6824 31.3793 11.5969 30.8487 10.9616C30.8486 10.9615 30.8485 10.9613 30.8484 10.9612L30.8477 10.9603L30.8443 10.9563L30.8196 10.9274C30.7961 10.9002 30.7587 10.8572 30.7078 10.8C30.606 10.6857 30.4505 10.5152 30.2449 10.3014C29.8333 9.87335 29.2238 9.27461 28.4457 8.60767C26.8812 7.26666 24.6778 5.68668 22.0679 4.64272C19.4692 3.60323 16.5098 3.11025 13.3657 3.86483C10.2269 4.61814 6.74108 6.6538 3.15233 10.9603C2.62199 11.5967 1.67614 11.6827 1.03973 11.1524C0.403309 10.622 0.31732 9.67619 0.847665 9.03977C4.75892 4.34624 8.77307 1.88188 12.6656 0.947673C16.5527 0.0147482 20.1558 0.646775 23.1821 1.85729C26.1972 3.06335 28.6813 4.85839 30.3981 6.3299C31.2606 7.06922 31.9401 7.73611 32.4074 8.2221C32.6413 8.46534 32.8227 8.66396 32.9479 8.80455C33.0106 8.87487 33.0592 8.93073 33.0934 8.97048L33.1339 9.01782L33.1459 9.03205L33.1498 9.03673L33.1512 9.03846Z",
    fill: "#3D0E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18C19.7614 18 22 15.7614 22 13C22 10.2386 19.7614 8 17 8C14.2386 8 12 10.2386 12 13C12 15.7614 14.2386 18 17 18Z",
    fill: "#FFB6BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 9C14.7909 9 13 10.7909 13 13C13 15.2091 14.7909 17 17 17C19.2091 17 21 15.2091 21 13C21 10.7909 19.2091 9 17 9ZM11 13C11 9.68629 13.6863 7 17 7C20.3137 7 23 9.68629 23 13C23 16.3137 20.3137 19 17 19C13.6863 19 11 16.3137 11 13Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEyeRegular);
export default __webpack_public_path__ + "static/media/ic_eye_regular.6937f344a721dbe6dac64c72f8446e06.svg";
export { ForwardRef as ReactComponent };